import React from "react";
import couldI from '../../images/home/cloud.png';

function CloudSolutions() {
  return (
    <>

      <Hero />

      <section className="service-content-section">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <img
                src={couldI}
                alt="Cloud Solutions"
                className="service-main-image"
              />
            </div>

            <div className="col-lg-6">
              <div className="service-content">
                <h2>Flexible Technology For Growing Businesses</h2>

                <p>
                  Cloud-based solutions allow businesses to access their
                  applications and data from different locations while
                  providing flexibility as business requirements change.
                </p>

                <p>
                  We help design and develop applications that are suitable
                  for modern cloud environments and scalable business needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-features-section">
        <div className="container">
          <div className="section-heading text-center">

            <h2>Benefits Of Cloud Solutions</h2>
          </div>

          <div className="row g-4">
            {[
              ["Accessibility", "Access applications and business information from wherever your team works."],
              ["Scalability", "Scale your technology environment as your business requirements grow."],
              ["Flexibility", "Build solutions that can adapt to changing business and technology needs."]
            ].map(([title, text]) => (
              <div className="col-lg-4 col-md-6" key={title}>
                <div className="service-feature-card">
                  <h3>{title}</h3>
                  <p>{text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTA />
    </>
  );
}

function Hero() {
  return (
    <section
      className="service-page-hero"
      style={{ backgroundColor: '#002952' }}
    >
      <div className="container">
        <div className="service-hero-content">
          <h1>Cloud Solutions</h1>
          <p style={{ color: '#FF7D37' }}>
            Flexible and scalable technology solutions for modern businesses.
          </p>
        </div>
      </div>
    </section>
  );
}

function CTA() {
  return (
    <section className="service-cta-section">
      <div className="container">
        <div className="service-cta-box">
          <div>

            <h2>Ready For The Cloud?</h2>
            <p>Let's discuss your cloud application requirements.</p>
          </div>
          <a href="/contactus" className="service-cta-button">
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}

export default CloudSolutions;